<div class="wrapper">

  <app-sidenav/>

  <app-topbar/>

  <div class="content-page">

    <router-outlet/>

    <app-footer/>

  </div>

</div>
